import { DEFAULT_CONFIG } from "./data/default-config";
import type { YinshConfig } from "./types/game-config";
import type { YinshState } from "./types/game-state";

export interface InitGameOptions {
  readonly player1Name?: string;
  readonly player2Name?: string;
  readonly config?: YinshConfig;
}

export function initGame(options: InitGameOptions = {}): YinshState {
  const {
    player1Name = "Player 1",
    player2Name = "Player 2",
    config = DEFAULT_CONFIG,
  } = options;

  return {
    phase: "RING_PLACEMENT",
    turn: 1,
    currentPlayer: "WHITE",
    players: [
      { color: "WHITE", name: player1Name, ringsOnBoard: 0, ringsScored: 0 },
      { color: "BLACK", name: player2Name, ringsOnBoard: 0, ringsScored: 0 },
    ],
    board: {},
    markersPool: config.markersTotal,
    winner: null,
    isDraw: false,
    pendingRows: [],
    opponentPendingRows: [],
    rowsRemovedThisTurn: 0,
    markerPlacedAt: null,
    lastMover: null,
  };
}
